export default __webpack_public_path__ + "static/media/Cabbage.b1dde0e1.jpg";